document.addEventListener('DOMContentLoaded', () => {
  const checkStoreListChildren = (storeList) => {
    // Translate phone labels
    storeList.querySelectorAll('#scasl-phone-label').forEach((label) => {
      if (!label.dataset.translated || label.dataset.translated !== 'true') {
        label.textContent = 'Telefonnummer';
        label.dataset.translated = 'true';
      }
    });

    // Translate Operating Hours titles
    storeList.querySelectorAll('#scasl-operating-hours-label').forEach((label) => {
      if (!label.dataset.translated || label.dataset.translated !== 'true') {
        label.textContent = 'Öffnungszeiten';
        label.dataset.translated = 'true';
      }
    });

    storeList.querySelectorAll('.main-oh-status, .end-oh-status').forEach((label) => {
      if (!label.dataset.translated || label.dataset.translated !== 'true') {
        label.textContent = label.textContent
          .replace('Closed', 'Geschlossen')
          .replace('Open', 'Geöffnet')
          .replace('Opens', 'Öffnet')
          .replace('Closes', 'Schließt')
          .replace('Closes soon', 'Schließt bald')
          .replace('Hours might differ', 'Die Öffnungszeiten können abweichen')
          .replace('Sun', 'So')
          .replace('Mon', 'Mo')
          .replace('Tue', 'Di')
          .replace('Wed', 'Mi')
          .replace('Thu', 'Do')
          .replace('Fri', 'Fr')
          .replace('Sat', 'Sa');
        label.dataset.translated = 'true';
      }
    });

    storeList.querySelectorAll('.expand-oh-status').forEach((label) => {
      if (!label.dataset.translated || label.dataset.translated !== 'true') {
        label.textContent = label.textContent.replace('Closed', 'Geschlossen').replace('Open now', 'Jetzt geöffnet');
        label.dataset.translated = 'true';
      }
    });

    storeList.querySelectorAll('.oh-item').forEach((label) => {
      if (!label.dataset.translated || label.dataset.translated !== 'true') {
        label.textContent = label.textContent
          .replace('Hours might differ', 'Die Öffnungszeiten können abweichen')
          .replace('Closed', 'Geschlossen')
          .replace('Open', 'Geöffnet')
          .replace('Opens', 'Öffnet')
          .replace('Closes', 'Schließt')
          .replace('Sunday', 'Sonntag')
          .replace('Monday', 'Montag')
          .replace('Tuesday', 'Dienstag')
          .replace('Wednesday', 'Mittwoch')
          .replace('Thursday', 'Donnerstag')
          .replace('Friday', 'Freitag')
          .replace('Saturday', 'Samstag');
        label.dataset.translated = 'true';
      }
    });

    // Translate CTA buttons
    storeList.querySelectorAll('#scasl-web').forEach((label) => {
      if (!label.dataset.translated || label.dataset.translated !== 'true') {
        label.textContent = 'Webseite';
        label.dataset.translated = 'true';
      }
    });

    // Translate "No limit" in radius dropdown
    const noLimitLabel = document.querySelector('#scasl-radius-container option[value="0"]');
    if (noLimitLabel && (!noLimitLabel.dataset.translated || noLimitLabel.dataset.translated !== 'true')) {
      noLimitLabel.textContent = 'Keine Begrenzung';
      noLimitLabel.dataset.translated = 'true';
    }
  };

  // watch for storeList itself
  const onStoreListReady = (bodyObserver) => {
    const storeList = document.querySelector('.scasl-location-list');
    if (storeList) {
      checkStoreListChildren(storeList);

      if (bodyObserver) {
        bodyObserver.disconnect();
      }

      const storeListObserver = new MutationObserver(() => {
        checkStoreListChildren(storeList);
      });

      storeListObserver.observe(storeList, {
        childList: true,
        subtree: true,
      });
    }
  };

  const bodyObserver = new MutationObserver(() => {
    onStoreListReady(bodyObserver);
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  onStoreListReady(bodyObserver);
});
